const AccountShimmer = () => {
    return (
        <li className="list-group-item bg-transparent border-0 px-0 border-bottom">
            <div className="row fs-5 px-3">
                <div className="col-11 py-2 row">
                    <div className="col-8 d-flex align-items-center">
                        <div className="shimmer-wrapper" style={{ width: '60%', height: '24px' }}></div>
                        <div className="shimmer-wrapper ms-2" style={{ width: '40px', height: '24px', borderRadius: '5px' }}></div>
                    </div>
                    <div className="col-4 text-end d-flex justify-content-end align-items-center">
                        <div className="shimmer-wrapper" style={{ width: '50px', height: '24px' }}></div>
                    </div>
                </div>
                <div className="col-1 d-flex justify-content-end align-items-center">
                    <div className="shimmer-wrapper" style={{ width: '4px', height: '24px', borderRadius: '2px' }}></div>
                </div>
            </div>
        </li>
    );
};

export default AccountShimmer;
